module.exports = __webpack_public_path__ + "img/ZTOBUHaveOrder_03.b76afaee.jpg";